export default async function ({store, redirect }) {
  if (!store.state.frontend.auth.token) {
    return redirect('/auth/login')
  }
}
